import { defineStore } from "pinia";
import axios from "axios";
import Swal from "sweetalert2";
import { piniaPlugin } from "../../index";
import { eventBus } from "../../../assets/eventBus";

export const useDeleteStore = defineStore("delete", {
    state: () => ({
        store: piniaPlugin(),
        deleteItems: []
    }),
    getters: {},
    actions: {
        multipleDeleteFolderFile(userTypeAbbr, item = null) {
            let routeURL = route(userTypeAbbr + "-vault-delete-multiple");
            let title = "Are you sure you want to delete selected items?";
            let text = "Deletion of this items will be moved to trash!";
            this.deleteItems = [];
            if (item != null) {
                const type = item.dataType === 'folders' ? 'folder' : 'file';
                title = `Are you sure you want to delete this ${type}?`;
                text = "Deletion of this item will be moved to trash!";
                this.deleteItems.push({
                    id: item.encryptedId,
                    dataType: item.dataType,
                    type: item.type,
                });
            } else {
                this.deleteItems = this.store.useMultiSelect.selectedItems;
            }
            Swal.fire({
                text: text,
                title: title,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.store.useMultiSelect.showTopProgress = true;
                    axios
                        .post(routeURL, { items: this.deleteItems }, {})
                        .then((response) => {
                            this.store.useMultiSelect.toast = {
                                isSuccess: response.data.success,
                                successMsg: response.data.message,
                                isToastMessage: true,
                            };
                            eventBus.reloadFolderFile("Delete", "folders");
                            eventBus.reloadFolderFile("Delete", "files");
                            this.store.useMultiSelect.showTopProgress = false;
                        })
                        .catch((err) => {
                            if (err.response.status == 422) {
                                if (err.response.data.errors.items) {
                                    this.store.useMultiSelect.toast = {
                                        isSuccess: false,
                                        successMsg:
                                            err.response.data.errors.items[0],
                                        isToastMessage: true,
                                    };
                                }
                            } else {
                                this.store.useMultiSelect.toast = {
                                    isSuccess: err.response.data.success,
                                    successMsg: err.response.data.message,
                                    isToastMessage: true,
                                };
                            }
                            this.store.useMultiSelect.showTopProgress = false;
                        });
                }
            });
        },
    },
});